<div class="progress-container">
  <mat-progress-bar mode="determinate" value="100"></mat-progress-bar>
</div>

<div id="riepilogo">
  <div class="title-container">
    <img class="image-success" [src]="successImage"  alt=""/>
    <div class="info">
      <span class="subtitle">{{ "complete_booking.title" | translate }}</span>
      <h1 class="title">{{ outcomeTitle | translate }}</h1>
    </div>
  </div>

  @if (!isSuccess) {
    <div class="wrap-sub-title-class">
      <div class="sub-title-class">{{ errorMessage | translate }}</div>
    </div>
  } @else {
    <div class="body-riepilogo">
      <ul>
        @if (users_in_wl && users_in_wl.length > 0) {
          <li class="warning">
            <img class="icon" src="../../../assets/img/alert.svg" alt="alert" />
            <div class="wrap-info">
              <div class="title">{{ "warning" | translate }}</div>
              @if (users_in_wl.length == 1) {
                <div class="content">
                  1 {{ "complete_booking.message" | translate }}
                </div>
              }@else {
                <div class="content" >
                  {{ users_in_wl.length }}
                  {{ "complete_booking.message2" | translate }}
                </div>
              }
            </div>
          </li>
        }

        <li>
          <div class="title">{{ "complete_booking.event" | translate }}</div>
          <div class="content">
            {{
              eventObject!.event_name[userLanguage] ||
              eventObject!.event_name[languages.default]
            }}
          </div>
        </li>
        <li>
          <div class="title">{{ "complete_booking.form_date" | translate }}</div>
          <div class="content">{{ event_date }}</div>
        </li>
        <li>
          <div class="title">{{ "complete_booking.form_time" | translate }}</div>
          <div class="content">{{ convertTime(event_time, userLanguage) }}</div>
        </li>
        <!-- <li>
          <div class="title">{{ 'summary.event_location' | translate }}</div>
          <div class="content">{{ event_location }}</div>
        </li> -->
        <li>
          @if (!isMassive) {
            <div class="title">
              {{ "complete_booking.participants" | translate }}
            </div>
            @for (el of profiles; track el.uuid_passenger) {
              <div class="content">{{ el.displayName }}</div>
            }
          } @else {
            <div class="title">
            {{ "complete_booking.num_participants" | translate }}
            </div>
            <div class="content">{{ number_of_users }}</div>
          }
        </li>
      </ul>
    </div>
    <div class="final-message">
      {{ "complete_booking.note" | translate }}
    </div>
  }

  <div class="buttons">
    <button class="mini-button annulla" (click)="goTo('event-list')">
      {{ "another_reservation" | translate }}
    </button>
    @if (isMassive || userService.uuidPassenger) {
      <button
        class="mini-button conferma"
        (click)="termina()"
      >
        {{ "finish_operations" | translate }}
      </button>
    }

  </div>
</div>
